let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jP88y")).then(() => parcelRequire('kE8uV'));